import { SelectChangeEvent } from '@mui/material';
import { FormControl } from '../FormControl';
import { LibSelect } from '../LibSelect';
import { MenuItem } from '../MenuItem';
import { SelectLabelStyled } from './styled';

type SelectProps = {
  options: Array<string>;
  onChange: (event: SelectChangeEvent) => void;
  labelName?: string;
  className?: string;
  name: string;
  value: string;
};

export const Select = ({ options, onChange, labelName, name, value, className }: SelectProps) => {
  return (
    <FormControl className={className}>
      {labelName && <SelectLabelStyled variant="bodySmallSemiBold">{labelName}</SelectLabelStyled>}
      <LibSelect value={value} onChange={onChange} displayEmpty name={name}>
        {options.map((item) => (
          <MenuItem key={item} value={item}>
            {item}
          </MenuItem>
        ))}
      </LibSelect>
    </FormControl>
  );
};
